import { call, put, takeEvery } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import {
  ContractorPortalDownloadCertificate,
  ContractorPortalFetchCertificates,
} from 'src/constants/actionTypes'
import { ApiService, callContractorPortalSecureApi } from '../api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { ContractorPortalCertificate } from 'src/interfaces/contractorPortal'
import { captureSentryError } from 'src/utils/sentry'
import { getApiErrorMessage } from 'src/utils/errorHandlers'

function* onFetchCertificates(action: AsyncAction<void, ContractorPortalCertificate[]>) {
  try {
    const { payload }: { payload: ContractorPortalCertificate[] } = yield call(
      callContractorPortalSecureApi,
      Endpoints.ContractorPortalFetchCertificates,
      {
        apiService: ApiService.Paraworks,
      },
    )

    yield put(ContractorPortalFetchCertificates.success(payload))

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.contractorPortal.onFetchCertificates] error',
    })

    const errorMessage = getApiErrorMessage(err, 'Failed to fetch certificates')

    yield put(ContractorPortalFetchCertificates.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

interface DownloadCertificateRequest {
  certificateId: string
}

function* onDownloadCertificate(action: AsyncAction<DownloadCertificateRequest, Blob>) {
  try {
    const { payload }: { payload: Blob } = yield call(
      callContractorPortalSecureApi,
      Endpoints.ContractorPortalDownloadCertificate,
      {
        apiService: ApiService.Paraworks,
        params: [
          {
            field: ':certificateId',
            value: action.payload.certificateId,
          },
        ],
        returnBlob: true,
      },
    )

    yield put(ContractorPortalDownloadCertificate.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.contractorPortal.onDownloadCertificate] error',
    })

    const errorMessage = getApiErrorMessage(err, 'Failed to download certificate')

    yield put(ContractorPortalDownloadCertificate.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* contractorPortalCertificatesSaga() {
  yield takeEvery(ContractorPortalFetchCertificates.type.REQUEST, onFetchCertificates)
  yield takeEvery(ContractorPortalDownloadCertificate.type.REQUEST, onDownloadCertificate)
}
